module.exports = __webpack_public_path__ + "static/8-f6458b66fcaa10892ef0a7d601eae85c.jpg";